export default __webpack_public_path__ + "static/media/logo-patrocinador3.63726141.svg";